export const suggestionsConstants = {
  HOMEWORK_SUGGESTION: 'HOMEWORK_SUGGESTION',
  ADDITIONAL_SUGGESTION: 'ADDITIONAL_SUGGESTION',
  RESET_SUGGESTIONS: 'RESET_SUGGESTIONS',
}
